var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup17226(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.267,
    height: 35.5,
    viewBox: "0 0 35.267 35.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17226",
    "data-name": "Group 17226",
    transform: "translate(-617.781 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo",
    d: "M20.382,14.82,33.131,0H30.11L19.04,12.868,10.2,0H0L13.371,19.459,0,35H3.021l11.69-13.589L24.049,35h10.2L20.381,14.82Zm-4.138,4.81-1.355-1.938L4.11,2.274H8.751l8.7,12.443L18.8,16.655,30.111,32.829H25.471l-9.227-13.2Z",
    transform: "translate(618.325)",
    fill: "#858689",
    stroke: "#858689",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30940",
    "data-name": "Path 30940",
    d: "M-1176.245,13211.513h6.62l22.128,31.837h-7.448Z",
    transform: "translate(1797.32 -13209.932)",
    fill: "#858689",
    stroke: "#858689",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup17226);
export default __webpack_public_path__ + "static/media/Group17226.12d6294bfa8dcaae042c6ec7f7ed1522.svg";
export { ForwardRef as ReactComponent };